import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { APIintegrationDisconnect } from '../../api/Integrations';

import ImporterModalConnect from './ModalConnect';

const ImporterModalError = ({ importer }) => {
  const intl = useIntl();

  const handleRedirectToAuthUrl = () => {
    window.location = importer.auth_url;
  };

  if (importer?.service === 'googledrive') {
    APIintegrationDisconnect(importer.service);
  }

  return (
    <>
      {importer ? (
        <ImporterModalConnect
          relink={true}
          importer={importer}
          handleRedirectToAuthUrl={handleRedirectToAuthUrl}
        />
      ) : (
        <p className="error center">
          {intl.formatMessage({ defaultMessage: 'Oops, something went wrong!' })}
        </p>
      )}
      <p className="center">
        {intl.formatMessage({
          defaultMessage: 'If the issue still occurs, please <mail>contact us</mail>',
        }, {
          mail: msg => <a href="mailto:help@stockpress.co">{msg}</a>,
        })}
      </p>
    </>
  );
};

ImporterModalError.propTypes = {
  importer: PropTypes.object,
};

ImporterModalError.defaultProps = {
  importer: null,
};

export default ImporterModalError;
